import DispatcherEvent from "./DispatcherEvent";
import { toast } from "react-toastify";
import io from "socket.io-client";

export default class ConsultSignaler {
    // const { l } = useContext(LangCtx);
    constructor(language) {
        // property definitions
        this.events = {};
        this.wsUri = process.env.REACT_APP_socket; //'ws://localhost:9001/'
        // this.wsUri = "wss://8a7v2yzkva.execute-api.ap-southeast-1.amazonaws.com/dev";
        this.socket = null;
        this.isConnected = false;
        this.subscribers = [];
        this.reConnect = false;
        this.uid = null;
        this.isBusy = false;
        this.resendwr = true;
        this.resendCall = true;
        this.clientId = Date.now();
        this.deviceId = null;
        this.l = language;
    }

    dispatch(eventName, data) {
        const event = this.events[eventName];
        if (event) {
            event.fire(data);
        }
    }

    on(eventName, callback) {
        let event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        event.registerCallback(callback);
    }

    off(eventName, callback) {
        const event = this.events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
            event.unregisterCallback(callback);
            if (event.callbacks.length === 0) {
                delete this.events[eventName];
            }
        }
    }

    onOpen = (event) => {
        this.isConnected = true;
        this.dispatch("connected", event);
        // localStorage.removeItem("deviceId");
        // if(this.reConnect && this.uid) {
        //     this.subscribers.forEach((subscriber) => {
        //         this.subscribeOnlineStatus(subscriber, this.uid);
        //     });
        //     this.reConnect = false;
        // }
    };

    onClose = (event) => {
        console.log("Websocket Closed", event, this);
        this.isConnected = false;
        // // this.uid = null;
        // this.dispatch('off-subscribe', event.data);
        // this.dispatch('closed-ws', event.data);
        if (process.env.REACT_APP_isOffline === "true") {
            if (localStorage.getItem("sub")) {
                this.init(this.uid, this.role, true);
            } else {
                if (window.location.pathname !== "/") {
                    this.dispatch("disconnected");
                }
                this.socket = null;
                localStorage.removeItem("deviceId");
            }
        } else {
            if (this.socket) {
                this.init(this.uid, this.role, true);
            } else {
                localStorage.removeItem("sub");
                if (window.location.pathname !== "/") {
                    this.dispatch("disconnected");
                }
                this.socket = null;
                localStorage.removeItem("deviceId");
            }
            // Auth.currentSession().then(mySession => {

            // }).catch(err => {
            //     console.log("err ===== ", err);

            // })
        }
    };

    onMessage = (event) => {
        const data = JSON.parse(event.data);
        switch (data.command) {
            case "ENTERWR":
                this.dispatch(`wrstatus${data.body.apptId}`, data.body.senderId);
                break;
            case "EXITWR":
                this.dispatch(`wrstatus${data.body.apptId}`, null);
                break;
            case "RECIEVEMESSAGE":
                this.dispatch(`RECIEVEMESSAGE`, data);
                break;
            case "CALLREQ":
                this.dispatch("recive-call", data.body);
                this.resendCall = true;
                break;
            case "CALLREQ_ACK":
                this.dispatch("disable-vc-button");
                break;
            case "DECLINEREQ_ACK":
                this.dispatch("enable-vc-button");
                break;
            case "CANCELREQ_ACK":
                this.dispatch("enable-vc-button");
                break;
            case "DECLINEREQ":
                this.dispatch("decline-request");
                let p_name = data.body.firstName ? data.body.firstName : "Patient";
                p_name += data.body.lastName ? " " + data.body.lastName : "";
                toast.success(`${p_name} ${this.l.declined_call_request}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                this.resendCall = true;
                break;
            case "CANCELREQ":
                let d_name = data.body.firstName ? data.body.firstName : "Doctor";
                d_name += data.body.lastName ? " " + data.body.lastName : "";
                toast.success(`Dr. ${d_name} ${this.l.cancelled_call_request}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                this.resendCall = true;
                this.dispatch("cancel-call", data?.body);
                break;
            case "ACCEPTREQ":
                this.dispatch("accept-call");
                this.resendCall = true;
                break;
            case "ACCEPTREQ_ACK":
                this.dispatch("cancel-call", { apptId: data.apptId });
                this.resendCall = true;
                break;
            case "PENDLIST":
                this.dispatch("reload-pending-list");
                break;
            case "APPTSTATUS":
                this.dispatch(`reload-appt-list`);
                break;
            case "receivedDeleteUserMessage":
                this.dispatch(`receivedDeleteUserMessage`, data.deleted);
                break;
            default:
                return;
        }
        // if(data.command === 'PRESENCE') {
        //     this.dispatch(data.uid, data.status);
        // }
        // if(data.command === 'CALLREQUEST') {
        //     // if(is)
        //     this.dispatch('oncall-receiver', data.body);
        // }

        // if(data.command === 'CALLDECLAINED') {
        //     this.dispatch('call-declained', {});
        // }

        // if(data.command === 'CALLACCEPTED') {
        //     this.dispatch('call-accepted', {selfId: data.body.remoteId, remoteId: data.body.senderId, publishVideo: true});
        // }
        // if(data.command === 'ENDCALL') {
        //     this.dispatch('oncall-ended', {});
        // }
        // if (data.command === 'INDCHAT') {
        //     console.log("store ==== ", window.store);
        //     let {store} = window;
        //     if (store.getState().dashboard.selectedUser !== data.body.createdBy) {
        //         store.dispatch(setReadCount(data.body.createdBy));
        //     } else {
        //         this.dispatch('recive-ind-chat', data.body);
        //     }
        // }
    };

    onError = (event) => {
        console.log("Websocket Error", event);
        if (window.location.pathname !== "/") {
            this.dispatch("disconnected");
        }
        this.socket = null;
        localStorage.removeItem("sub");
        // localStorage.removeItem('token');
    };

    init = function (uid, role, reConnect = false) {
        try {
            if (process.env.REACT_APP_isOffline === "true") {
                let token = localStorage.getItem("token");
                this.socket = new WebSocket(`${this.wsUri}?userId=${uid}&role=${role}&token=${token}`);
            } else {
                this.deviceId = localStorage.getItem("deviceId") || this.deviceId;

                // let url = `${this.wsUri}?userId=${uid}&role=${role}&clientId=${this.clientId}`;
                // url += this.deviceId && this.deviceId !== "" && this.deviceId !== null ? `&deviceId=${this.deviceId}` : "";
                // this.webSocket = new WebSocket(url);
                let clientId = new Date().valueOf();
                if (localStorage.getItem("clientId")) {
                    clientId = localStorage.getItem("clientId");
                } else {
                    localStorage.setItem("clientId", clientId);
                }
                this.socket = io(this.wsUri, {
                    query: {
                        userId: uid,
                        role: role,
                        // token: token,
                        clientId: clientId,
                        deviceId: this.deviceId && this.deviceId !== "" && this.deviceId !== null ? this.deviceId : "",
                    },
                    transports: ["websocket", "polling"],
                });
            }
            // this.webSocket.onopen = this.onOpen;
            // this.webSocket.onclose = this.onClose;
            // this.webSocket.onmessage = this.onMessage;
            // this.webSocket.onerror = this.onError;
            // window.webSock = this.webSocket;
            this.socket.on("connect", this.onOpen);
            this.socket.on("disconnect", this.onClose);
            this.socket.on("error", this.onError);
            this.socket.on("ENTERWR", (datastr) => {
                let data = JSON.parse(datastr);
                const apptId = data.data?.apptId || data.apptId;
                const senderId = data.data?.senderId || data.senderId;
                this.dispatch(`wrstatus${apptId}`, senderId);
            });
            this.socket.on("RECIEVEMESSAGE", (datastr) => {
                let data = JSON.parse(datastr);
                this.dispatch(`RECIEVEMESSAGE`, data);
            });
            this.socket.on("UNSEEN_COUNT", (datastr) => {
                let data = JSON.parse(datastr);
                this.dispatch(`UNSEEN_COUNT`, data);
            });
            this.socket.on("TOTAL_UNSEEN_CHAT_COUNT", (datastr) => {
                let data = JSON.parse(datastr);
                this.dispatch(`TOTAL_UNSEEN_CHAT_COUNT`, data);
            });
            this.socket.on("EXITWR", (datastr) => {
                let data = JSON.parse(datastr);
                const apptId = data.data?.apptId || data.apptId;
                this.dispatch(`wrstatus${apptId}`, null);
            });
            this.socket.on("CALLREQ", (data) => {
                this.dispatch("recive-call", data);
                this.resendCall = true;
            });
            this.socket.on("DECLINEREQ", (datastr) => {
                let data = JSON.parse(datastr);
                this.dispatch("decline-request");
                let p_name = data.firstName ? data.firstName : "Patient";
                p_name += data.lastName ? " " + data.lastName : "";
                toast.success(`${p_name} ${this.l.declined_call_request}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });

            this.socket.on("DECLINEREQ_ACK", (datastr) => {
                JSON.parse(datastr);
                this.dispatch("acerdec-call-ack");
            });

            this.socket.on("CANCELREQ", (data) => {
                let d_name = data.firstName ? data.firstName : "Doctor";
                d_name += data.lastName ? " " + data.lastName : "";
                toast.success(`Dr. ${d_name} ${this.l.cancelled_call_request}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                this.resendCall = true;
                this.dispatch("cancel-call");
            });

            this.socket.on("CANCELREQ_ACK", (datastr) => {
                JSON.parse(datastr);
                this.dispatch("cancel-call-ack");
            });

            this.socket.on("ACCEPTREQ", (data) => {
                this.dispatch("accept-call");
                this.resendCall = true;
            });

            this.socket.on("ACCEPTREQ_ACK", (datastr) => {
                JSON.parse(datastr);
                this.dispatch("acerdec-call-ack");
            });

            this.socket.on("PENDLIST", (data) => {
                this.dispatch("reload-pending-list");
            });

            this.socket.on("APPTSTATUS", (data) => {
                this.dispatch(`reload-appt-list`);
            });

            localStorage.setItem("sub", uid);
            this.reConnect = reConnect;
            this.uid = uid;
            this.role = role;
        } catch (e) {
            console.log("error in signelar init ==== ", e);
            this.init(uid, role, false);
        }
    };

    closeSocket = () => {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    };

    enterWaitingRoom = (apptId, userId) => {
        if (this.isConnected && this.socket) {
            this.resendwr = false;
            // let message = {
            //     action: "onMessage",
            //     message: "ENTERWR",
            //     uid: userId,
            //     data: {
            //         senderId: this.uid,
            //         apptId: apptId,
            //     },
            // };
            const message = {
                senderId: this.uid,
                apptId: apptId,
                receiverId: userId,
            };
            this.socket.emit("ENTERWR", message);
            this.dispatch("enterwr-sent");
        } else if (this.socket && this.resendwr) {
            setTimeout(() => {
                this.enterWaitingRoom(apptId, userId);
            }, 300);
        }
        // else {
        //     this.dispatch('disconnected');
        // }
    };

    exitWaitingRoom = (apptId, userId) => {
        this.resendwr = true;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "EXITWR",
                uid: userId,
                data: {
                    senderId: this.uid,
                    apptId: apptId,
                },
            };
            this.socket.emit("EXITWR", message);
            this.dispatch("exitwr-sent");
        }
        // else if (this.socket && this.resend) {
        //     setTimeout(() => {
        //         this.exitWaitingRoom(apptId, userId);
        //     }, 300);
        // }
        // else {
        //     this.dispatch('disconnected');
        // }
    };

    getChatCount = (apptId) => {
        this.resendwr = true;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "CHATCOUNT",
                uid: this.uid,
                data: {
                    senderId: this.uid,
                    apptId: apptId,
                },
            };
            this.socket.emit("CHATCOUNT", message);
            this.dispatch("CHATCOUNT");
        }
    };

    getTotalChatCount = () => {
        this.resendwr = true;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "TOTALCHATCOUNT",
                uid: this.uid,
                data: {
                    senderId: this.uid,
                },
            };
            this.socket.emit("TOTALCHATCOUNT", message);
            this.dispatch("TOTALCHATCOUNT");
        }
    };

    sendCahtMessage = (datas, apptId) => {
        console.log("🚀 :::::::::::::::", datas, apptId);

        this.resendwr = true;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "SENDCHATMESSAGE",
                uid: datas.userId,
                data: {
                    senderId: this.uid,
                    apptId: apptId,
                    datas,
                },
            };
            this.socket.emit("SENDCHATMESSAGE", message);
            this.dispatch("SENDCHATMESSAGE");
        }
    };

    seenChat = (apptId) => {
        this.resendwr = true;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "SEENCHAT",
                uid: this.uid,
                data: {
                    senderId: this.uid,
                    apptId: apptId,
                },
            };
            this.socket.emit("SEENCHAT", message);
            this.dispatch("SEENCHAT");
        }
    };

    deleteUserMessage = (data) => {
        this.resendwr = false;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "sendDeleteUserMessage",
                uid: data.userId,
                data: data.data,
            };
            this.socket.send(JSON.stringify(message));
            this.dispatch("join");
        }
    };

    joinmeet = (userId, apptId) => {
        this.resendwr = true;
        if (this.isConnected && this.socket) {
            let message = {
                action: "onMessage",
                message: "join",
                userId: userId,
                appointmentId: apptId,
            };
            this.socket.send(JSON.stringify(message));
            this.dispatch("join");
        }
    };

    sendCallRequest = (doctorData, userId) => {
        console.log("🚀 :::::::::::::::", doctorData, userId, this.isConnected, this.socket);
        if ((this.isConnected && this.socket) || (this.socket && this.socket.connected)) {
            // doctorData["senderId"] = this.uid;
            this.resendCall = false;
            // let message = {
            //     action: "onMessage",
            //     message: "CALLREQ",
            //     uid: userId,
            //     data: doctorData,
            // };
            doctorData["senderId"] = this.uid;
            doctorData["patientId"] = userId;
            this.socket.emit("CALLREQ", {
                data: doctorData,
            });
            this.dispatch("callreq-sent");
        } else if (this.socket && (this.resendCall || !this.isConnected)) {
            console.log(
                "🚀 >>>>>>>>>> resendCall - Socket exists but not connected. Socket.connected:",
                this.socket.connected,
                "isConnected:",
                this.isConnected
            );
            setTimeout(() => {
                this.sendCallRequest(doctorData, userId);
            }, 300);
        }
    };

    declineCallRequest = (userId, patientData) => {
        if (this.isConnected && this.socket) {
            this.resendCall = false;
            if (this.uid && patientData) {
                patientData["senderId"] = this.uid;
                patientData["receiverId"] = userId;
            }
            this.socket.emit("DECLINEREQ", {
                data: patientData,
            });
            // let message = {
            //     action: "onMessage",
            //     message: "DECLINEREQ",
            //     uid: userId,
            //     data: patientData,
            // };
            // this.socket.send(JSON.stringify(message));
            this.dispatch("declinereq-sent");
        } else if (this.socket && this.resendCall) {
            setTimeout(() => {
                this.declineCallRequest(userId, patientData);
            }, 300);
        }
        // else {
        //     this.dispatch('disconnected');
        // }
    };

    cancelCallRequest = (userId, doctorData) => {
        if (this.isConnected && this.socket) {
            this.resendCall = true;
            // doctorData["senderId"] = this.uid;
            // let message = {
            //     action: "onMessage",
            //     message: "CANCELREQ",
            //     uid: userId,
            //     data: doctorData,
            // };
            // this.socket.send(JSON.stringify(message));
            doctorData["patientId"] = userId;
            this.socket.emit("CANCELREQ", {
                data: doctorData,
            });
            this.dispatch("cancelreq-sent");
        } else if (this.socket && !this.resendCall) {
            setTimeout(() => {
                this.cancelCallRequest(userId);
            }, 300);
        }
        // else {
        //     this.dispatch('disconnected');
        // }
    };

    acceptCallRequest = (userId) => {
        if (this.isConnected && this.socket) {
            this.resendCall = false;
            // let message = {
            //     action: "onMessage",
            //     message: "ACCEPTREQ",
            //     uid: userId,
            //     data: { senderId: this.uid },
            // };
            // this.socket.send(JSON.stringify(message));
            this.socket.emit("ACCEPTREQ", {
                data: { senderId: this.uid, receiverId: userId },
            });
            this.dispatch("acceptreq-sent");
        } else if (this.socket && this.resendCall) {
            setTimeout(() => {
                this.acceptCallRequest(userId);
            }, 300);
        }
    };

    renderAppoints = (userId, msg, data = null) => {
        if (this.isConnected) {
            // let message = {
            //     action: "onMessage",
            //     message: msg,
            //     uid: userId,
            //     data: data,
            // };
            // this.webSocket.send(JSON.stringify(message));
            this.socket.emit(msg, {
                uid: userId,
                data: data,
            });
        }
        // else {
        //     this.dispatch('disconnected');
        // }
    };

    endCall = (id = null, receverId = null) => {
        if (this.isConnected) {
            let message = {
                action: "onMessage",
                message: "ENDCALL",
                uid: receverId !== null ? receverId : this.uid,
                data: {
                    senderId: this.uid,
                    apptId: id,
                },
            };
            this.socket.send(JSON.stringify(message));
        }
    };
}
